import { createSingleEntryStore, createSingleEntryStoreSelector } from '../createSingleEntryStore';
import { fetchJiraProjects } from 'services/savings';

export const useJiraCloudProjectsStore = createSingleEntryStore({
  fetchData: () => fetchJiraProjects('jira_cloud')
});

export const useJiraCloudProjects = createSingleEntryStoreSelector(useJiraCloudProjectsStore);
